import React, { useEffect, useState } from 'react';
import { message, DatePicker, Form, Input, Select } from "antd";
import { Button } from "evergreen-ui";
import Firebase from "../../Firebase/Firebase";
import { useListVals } from "../../Firebase/databaseHooks";
import { getDatabase, ref } from "firebase/database";
import FireFetch from "../../Firebase/FireFetch";
import { useAuth } from "../../AuthContext/AuthContext";
import { isActiveUserStatus } from "../../../constants/userStatus";
import { filterSelectOption, sortSelectOptions } from "../../utils/selectOptions.js";


var db = getDatabase(Firebase);
const moment = require("moment");
const AddPriority = (props) => {
    const { canAccessModule } = useAuth();
    const canCreatePriority = canAccessModule("COMMUNITY_PRIORITIES", "create");

    const [showLoading, setShowLoading] = useState(false);
    const [organizationArray] = useListVals(ref(db, "talmidsdb/organisations"));
    const [communityArray] = useListVals(ref(db, "talmidsdb/communities"));
    const [userArray] = useListVals(ref(db, "talmidsdb/users"));
    const [initiativeArray] = useListVals(ref(db, "talmidsdb/initiatives"));


    useEffect(() => {
        if (userArray) {
        }
    }, [userArray]);


    const handleCreate = (values) => {
        if (!canCreatePriority) {
            message.error("You do not have permission to create priorities.");
            return;
        }

        setShowLoading(true);
        var timeStamp = moment().format("YYYY-MM-DDThh:mm:ss");
        var objectID = Array(6).fill("ABCDEFGHIJKLMNOPQRSTUVWXYZ123456789abcdefghijklmnopqrstuvwxyz")
            .map(function (x) { return x[Math.floor(Math.random() * x.length)] }).join('');

        var priorityObject = values;

        priorityObject.priorityID = objectID;
        priorityObject.timeStamp = timeStamp;
        priorityObject.startDate = values.startDate.format("YYYY-MM-DDThh:mm");
        priorityObject.endDate = values.endDate.format("YYYY-MM-DDThh:mm");


        const output = FireFetch.SaveTODB("priorities", objectID, priorityObject);
        output.then((result) => {
            console.log(result);
            if (result === "success") {
                FireFetch.addLog("priorities", objectID, "Create");
                message.success("Priority added successfully");
                props.modal(false);
                setShowLoading(false);
            } else {
                message.error("Unable to add Priority an error occurred :: " + result);
                setShowLoading(false);
            }
        });

    }



    return (
        <>
            <Form layout={"vertical"}
                onFinish={handleCreate}>

                <Form.Item label="Priority"
                    name="priority"
                    rules={[{ required: true, message: 'Enter priority!' }]}
                >
                    <Input placeholder="Enter Priority" id="priority" />
                </Form.Item>

                <Form.Item label="Organization"
                    name="organisationID"
                    rules={[{ required: true, message: 'Choose Organization!' }]}>
                    <Select placeholder="Select organisation"
                        showSearch
                        optionFilterProp="children"
                        filterOption={filterSelectOption}
                        filterSort={sortSelectOptions}>
                        {organizationArray.map((item, index) => (
                            <Select.Option key={index} value={item.orgID}>{item.name}</Select.Option>
                        ))}

                    </Select>
                </Form.Item>
                <Form.Item label="Community"
                    name="communityID"
                    rules={[{ required: true, message: 'Choose Community!' }]}>
                    <Select placeholder="Select community"
                        showSearch
                        optionFilterProp="children"
                        filterOption={filterSelectOption}
                        filterSort={sortSelectOptions}>
                        {communityArray.map((item, index) => (
                            <Select.Option key={index} value={item.communityID}>{item.name}</Select.Option>
                        ))}

                    </Select>
                </Form.Item>
                <Form.Item label="Initiative"
                    name="initiativeID"
                    rules={[{ required: true, message: 'Choose initiative!' }]}>
                    <Select placeholder="Select initiative"
                        showSearch
                        optionFilterProp="children"
                        filterOption={filterSelectOption}
                        filterSort={sortSelectOptions}>
                        {initiativeArray.map((item, index) => (
                            <Select.Option key={index} value={item.initiativeID}>{item.initiative}</Select.Option>
                        ))}

                    </Select>
                </Form.Item>

                <Form.Item
                    label="Start Date"
                    name="startDate"
                    rules={[{ required: true, message: "Choose start date" }]}>
                    <DatePicker
                        placeholder="select starting date"
                        picker={"date"}
                        showTime={{ format: 'HH:mm' }}
                        className="w-100" />

                </Form.Item>
                <Form.Item
                    label="End Date"
                    name="endDate"
                    rules={[{ required: true, message: "Choose end date" }]}>
                    <DatePicker
                        placeholder="select ending date"
                        picker={"date"}
                        showTime={{ format: 'HH:mm' }}
                        className="w-100" />

                </Form.Item>

                <Form.Item label="Responsible User"
                    name="responsibleUserID"
                    rules={[{ required: true, message: 'Choose responsible user!' }]}>
                    <Select placeholder="Select user"
                        showSearch
                        optionFilterProp="children"
                        filterOption={filterSelectOption}
                        filterSort={sortSelectOptions}>
                        {userArray.filter((x) => isActiveUserStatus(x.userStatus)).map((item, index) => (
                            <Select.Option key={index} value={item.id}>{item.firstname + " " + item.surname}</Select.Option>
                        ))}

                    </Select>
                </Form.Item>


                <Button appearance="primary" htmlType="submit" loading={showLoading} disabled={!canCreatePriority}>
                    Create
                </Button>
            </Form>
        </>
    )
}

export default AddPriority;
